import moment from 'moment-timezone';

const getCurrentMomentYear = () => {
  const nowEST = moment();
  return nowEST.year();
};

export const shuffleArray = (array) => {
  // the Fisher-Yates algorithm
  let currentIndex = array.length;
  let randomIndex;
  while (currentIndex > 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
};

export default getCurrentMomentYear;
